import React from 'react';
import { Player } from '../types';

interface ScoreBoardProps {
  players: Player[];
  currentRound: number;
  dealerIndex: number | null;
}

const ScoreBoard: React.FC<ScoreBoardProps> = ({ players, currentRound, dealerIndex }) => {
  // Helper to get cumulative score up to a round for a player
  const getCumulativeScore = (player: Player, roundNumber: number): number => {
    return player.rounds
      .filter(r => r.roundNumber <= roundNumber)
      .reduce((sum, r) => sum + r.score, 0);
  };

  return (
    <div className="bg-white rounded-none shadow-lg p-6 mb-7 border-none w-full">
      <h2 className="text-2xl font-bold mb-4">Score Board</h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse bg-white rounded-none overflow-hidden shadow-sm">
          <thead>
            <tr className="border-b-2 border-gray-300">
              <th className="text-left p-2 font-bold"></th>
              {players.map((player, idx) => (
                <th
                  key={player.id}
                  className={`text-center p-2 font-bold text-sm ${dealerIndex === idx ? 'bg-blue-100 border-r-2 border-blue-400 border-l-2' : ''}`}
                >
                  {player.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRound > 0 && Array.from({ length: currentRound }, (_, i) => i + 1).map((roundNum) => (
              <tr key={roundNum} className="border-b border-gray-200">
                <td className="p-2 font-bold text-sm">Round {roundNum}</td>
                {players.map((player, idx) => {
                  const roundData = player.rounds.find(r => r.roundNumber === roundNum);
                  const cumulativeScore = getCumulativeScore(player, roundNum);
                  return (
                    <td
                      key={player.id}
                      className={`p-2 text-center text-sm ${dealerIndex === idx ? 'bg-blue-100 border-r-2 border-blue-400 border-l-2' : ''}`}
                    >
                      {roundData ? (
                        <div>
                          <div className="font-bold">{roundData.bid}/{roundData.tricks}</div>
                          <div className={`text-xs font-bold ${cumulativeScore > 0 ? 'text-green-600' : cumulativeScore < 0 ? 'text-red-600' : ''}`}>
                            {cumulativeScore}
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr className="border-t-2 border-gray-300 bg-gray-50">
              <td className="p-2 font-bold">Total</td>
              {players.map((player, idx) => (
                <td
                  key={player.id}
                  className={`p-2 text-center font-bold text-green-600 ${dealerIndex === idx ? 'bg-blue-100 border-r-2 border-blue-400 border-l-2' : ''}`}
                >
                  {player.totalScore}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScoreBoard; 